import { safeRetrieve, safeStore } from '../../utils/storage';
export class ChosenMediaStore {
    static instance;
    static STORAGE_KEY = 'chosen-media-devices';
    chosenVideoDevice = undefined;
    chosenAudioDevice = undefined;
    static getInstance() {
        if (!ChosenMediaStore.instance) {
            ChosenMediaStore.instance = new ChosenMediaStore();
        }
        return ChosenMediaStore.instance;
    }
    constructor() {
        this.loadFromStorage();
    }
    getChosenVideoDevice() {
        return this.chosenVideoDevice;
    }
    getChosenAudioDevice() {
        return this.chosenAudioDevice;
    }
    setChosenVideoDevice(device) {
        this.chosenVideoDevice = device;
        this.saveToStorage();
    }
    setChosenAudioDevice(device) {
        this.chosenAudioDevice = device;
        this.saveToStorage();
    }
    setChosenDevices(videoDevice, audioDevice) {
        this.chosenVideoDevice = videoDevice;
        this.chosenAudioDevice = audioDevice;
        this.saveToStorage();
    }
    clearChosenDevices() {
        this.chosenVideoDevice = undefined;
        this.chosenAudioDevice = undefined;
        this.saveToStorage();
    }
    saveToStorage() {
        const data = {
            videoDevice: this.chosenVideoDevice,
            audioDevice: this.chosenAudioDevice,
        };
        safeStore(ChosenMediaStore.STORAGE_KEY, data);
    }
    loadFromStorage() {
        const data = safeRetrieve(ChosenMediaStore.STORAGE_KEY, (value) => {
            const parsedData = value;
            if (parsedData.audioDevice !== undefined &&
                parsedData.videoDevice !== undefined) {
                return value;
            }
            throw 'Invalid device data retrieved';
        });
        if (data) {
            this.chosenVideoDevice = data.videoDevice || undefined;
            this.chosenAudioDevice = data.audioDevice || undefined;
        }
    }
}
